import React from 'react';
import BaseModel from '../../BaseModal';
import { FlexWrapperCenter, LineView, GapView } from '../../styles/WrapperStyles';

import styled, { css } from 'styled-components';

const ParentDiv = styled.div`
  width: 300px;
  height: 400px;
  border-radius: 20px;
`;

const TextView = styled.div`
  height: 24px;
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  ${props =>
        props.cursor &&
        css`
      cursor: pointer;
    `}
`;

const PhoneCodeModal = (props) => {
    return (
        <BaseModel closeModal={props.closeModal}>
            <ParentDiv>
                {props.list.map(item => (
                    <div key={item.id}>
                        <GapView height="20px" />
                        <FlexWrapperCenter>
                            <TextView
                                cursor
                                onClick={() => {
                                    props.itemSelected(item.code, item.id);
                                }}
                            >
                                {item.name} {item.code}
                            </TextView>
                        </FlexWrapperCenter>
                        <LineView width="200px" />
                    </div>
                ))}
            </ParentDiv>
        </BaseModel>
    );
};

export default PhoneCodeModal;
